import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PatientsService } from '../patients.service';
import { LoginService } from '../login.service';
import { PatexamsSidebarService } from './patexams-sidebar.service';
import { Patient } from '../patients/patient';

// Patient-history nav (/exams + /defaults); mode-aware: new es-patient-card or the legacy patient-info panel.
@Component({
  selector: 'app-patexams-nav',
  templateUrl: './patexams-sidebar.component.html',
  styleUrls: ['./patexams-sidebar.component.scss'],
  standalone: false,
})
export class PatexamsNavComponent implements OnInit {
  pat: Patient;

  constructor(
    public patService: PatientsService,
    public login: LoginService,
    private sidebarSvc: PatexamsSidebarService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.pat = this.patService.getPat();
  }

  get newSidebar(): boolean {
    return this.login.newSidebar;
  }

  get isDefaultsPage(): boolean {
    return this.router.url === '/defaults' || this.pat?.ID === 'default';
  }

  openPatDetails(): void {
    this.sidebarSvc.showPat$.next();
  }
}
